import bd from './building-page.json'
import buildingExp from './buildingExp.json'
import info from './info.json'
import bdList from './bd-list.json'
import facGlsry from './facility-glossary.json'
import pj from './project.json'

export default{
    bd, buildingExp, info, bdList, facGlsry, pj
}